import React from 'react';

export default [{
  name: 'CVS',
  render: (
    <div className='portfolio-item reveal' style={{ '--reveal-delay': '0s' }}>
      <div className='portfolio-item__title'>
        Software Engineer II
      </div>
      <div className='portfolio-item__desc'>
        Building front-end web features and internal tooling at CVS Health.
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-react"></i>
        <i className="fab fa-js"></i>
      </div>
      <div className='portfolio-item__links'>
        June 2020 – Present
      </div>
    </div>
  )
}, {
  name: 'CUBoulder',
  render: (
    <div className='portfolio-item reveal' style={{ '--reveal-delay': '0.12s' }}>
      <div className='portfolio-item__title'>
        Student Software Developer II
      </div>
      <div className='portfolio-item__desc'>
        Creating scripts, developing applications, and automating business processes for The University of Colorado Boulder Office of the Registrar.
      </div>
      <div className='portfolio-item__icon'>
        <i className="fas fa-code"></i>
      </div>
      <div className='portfolio-item__links'>
        August 2019 – May 2020
      </div>
    </div>
  )
}, {
  name: 'Aetna',
  render: (
    <div className='portfolio-item reveal' style={{ '--reveal-delay': '0.24s' }}>
      <div className='portfolio-item__title'>
        Software Development Internship – Aetna Health
      </div>
      <div className='portfolio-item__desc'>
        Developed front end web features in ReactJS for Aetna, a CVS health company.
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-js"></i>
        <i className="fab fa-react"></i>
      </div>
      <div className='portfolio-item__links'>
        May 2019 – August 2019
      </div>
    </div>
  )
}]



// WEBPACK FOOTER //
// ./src/pages/TechnicalPage/technical-items.js